import React, { Component } from "react";

import PropTypes from "prop-types";

import {
  Button,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  ButtonDropdown,
  DropdownMenu,
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import { tableLanguage } from "common/Constants/PageTable/tableLang";
import BooleanCellRender from "./CellRenderers/BooleanCellRender";
import DateTimeCellRender from "./CellRenderers/DateTimeCellRender";
import IncludeCellRenderer from "./CellRenderers/IncludeCellRenderer";
import ActivePassiveCellRender from "./CellRenderers/ActivePassiveCellRender";

import * as moment from "moment";

import "ag-grid-enterprise";
import "ag-grid-enterprise/styles//ag-grid.css";
import "ag-grid-enterprise/styles//ag-theme-alpine.css";

import { uniqueIdentifier } from "./CellRenderers/CellFunctions";


const ActionOperations = p => {
  return (
    <div>
      <UncontrolledDropdown>
        <DropdownToggle href="#" className="card-drop" tag="a">
          <i className="mdi mdi-dots-horizontal fon-size-16" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-start" positionFixed={true}>
          <DropdownItem
            style={{ display: p.edit ? "block" : "none" }}
            href="#"
            onClick={() => p.edit(p.data)}
          >
            <i className="mdi mdi-pencil font-size-16 text-success me-1" />{" "}
            {p.translate("edit")}
          </DropdownItem>
          <DropdownItem
            style={{ display: p.delete ? "block" : "none" }}
            onClick={() => p.delete(p.data)}
          >
            <i className="mdi mdi-trash-can font-size-16 text-danger me-1" />{" "}
            {p.translate("delete")}
          </DropdownItem>
          <DropdownItem
            style={{ display: p.detail ? "block" : "none" }}
            onClick={() => p.detail(p.data)}
          >
            <i className="mdi mdi-eye font-size-16 text-primary me-1" />{" "}
            {p.translate("details")}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};
class RavenAgTableDoubleClick extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statusBar: {
        statusPanels: [{ statusPanel: "agAggregationComponent" }],
      },
       overlayLoadingTemplate:'<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
       overlayNoRowsTemplate:'<span ></span>',
    };
  }


  onGridReady = params => {
    this.gridApi = params.api;
  };

  onBtnExportDataAsExcel = () => {
    let excelParams = {
      fileName: this.props.screenName + moment().format("DD-MM-YYYY hh-mm-ss"),
    };
    this.gridApi.exportDataAsExcel(excelParams);
  };

  onBtnExportDataAsCsv = () => {
    let csvParams = {
      fileName: this.props.screenName + moment().format("DD-MM-YYYY hh-mm-ss"),
    };
    this.gridApi.exportDataAsCsv(csvParams);
  };

  render() {
    const { recordList, recordcolumns } = this.props;
    const excelStyles = [
      {
        id: "stringType",
        dataType: "String" // Excel'de metin formatında olması için
      }
    ];
    const baseColumns = [
      {
        field: this.props.t("actions"),
        cellRenderer: ActionOperations,
        cellRendererParams: {
          translate: this.props.t,
          edit: this.props.onEditClick,
          delete: this.props.onDeleteClick,
          detail: this.props.onDetailClick,
        },
        singleClickEdit: true,
        suppressToolPanel: !this.props.actionItems,
        suppressColumnsToolPanel:!this.props.actionItems,
        maxWidth: 90,
        sortable: false,
        filter: false,
        hide:!this.props.actionItems
      },

      ...recordcolumns,
    ];

    return (
      <React.Fragment>
        <div className="d-flex align-items-center">
          <h5 className="mb-0 card-title flex-grow-1">
            {this.props.screenName}
          </h5>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="btn-group-horizantal" role="group"
            >
              <Button type="button"  style={{ display: this.props.onAddClick ? "" : "none" }} color="link" className="btn btn-outline" onClick={this.props.onAddClick}>
                <i className="bx bxs-file-plus font-size-15"></i>{" "}
                {this.props.t("addNew")}
              </Button>
              <ButtonDropdown style={{ display: this.props.exportOption ? "" : "none" }} isOpen={this.state.exportDataDrp} toggle={() => this.setState({ exportDataDrp: !this.state.exportDataDrp })}>
                <DropdownToggle caret color="link" className="btn btn-outline">
                  <i className="bx bx-export  font-size-15"></i>
                  {this.props.t("export")}
                </DropdownToggle>
                <DropdownMenu data-popper-placement="left">
                  <DropdownItem onClick={() => this.onBtnExportDataAsExcel()}>
                    {this.props.t("exportExcel")}
                  </DropdownItem>
                  <DropdownItem onClick={() => this.onBtnExportDataAsCsv()}>
                    {this.props.t("exportCsv")}
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
              <ButtonDropdown isOpen={this.state.operationsDrp} style={{ display: this.props.DropdownItems ? "" : "none" }} toggle={() => this.setState({ operationsDrp: !this.state.operationsDrp, })}>
                <DropdownToggle caret color="link" className="btn btn-outline">
                  <i className="bx bx-dots-vertical-rounded font-size-16" />
                </DropdownToggle>
                <DropdownMenu data-popper-placement="left">
                {this.props.DropdownItems ? this.props.DropdownItems.map((column) => (
                    <DropdownItem key={uniqueIdentifier()} onClick={() =>column.func(this.state)}>
                      {this.props.t(column.operationName)}
                    </DropdownItem>
                  )):<></>}
                </DropdownMenu>
              </ButtonDropdown>
            </div>
          </div>
        </div>
        <div className="ag-theme-alpine " style={{ height: "328px" }}>
          <AgGridReact
            defaultColDef={{
              flex: 1,
              sortable: true,
              filter: true,
              autosize: true,
              resizable: true,
              enableRowGroup:true,
              filterParams: {
              buttons: ['apply', 'reset']
            },
            }}
            frameworkComponents={{
              booleanCellRender: BooleanCellRender,
              dateTimeCellRender : DateTimeCellRender,
              includeCellRenderer : IncludeCellRenderer,
              activePassiveCellRender: ActivePassiveCellRender,
            }}
            statusBar={this.state.statusBar}
            rowData={recordList}
            columnDefs={baseColumns}
            enableRangeSelection={true}
            suppressMenuHide={true} 
            enableRangeHandle={true}
            overlayLoadingTemplate={this.state.overlayLoadingTemplate}
            overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
            animateRows={true}
            pagination={true}
            paginationPageSize={5}
            excelStyles={excelStyles}
            localeText={tableLanguage}
            onGridReady={this.onGridReady}
            paginationAutoPageSize={false}
            immutableData={true}
            getRowNodeId={data => data.guid}
            onRowDoubleClicked={(e) => this.props.selectedItems(e)}
            
            
          />
        </div>
      </React.Fragment>
    );
  }
}

RavenAgTableDoubleClick.propTypes = {
  onAddClick: PropTypes.func,
  selectedItems: PropTypes.any,
  onEditClick: PropTypes.func,
  actionItems: PropTypes.bool,
  SearchContent: PropTypes.any,
  DropdownItems: PropTypes.any,
  onDetailClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  handleAddRecordClick: PropTypes.func,
  screenName: PropTypes.string,
  recordList: PropTypes.any,
  exportOption: PropTypes.bool,
  recordcolumns: PropTypes.any,
  record: PropTypes.any,
  show: PropTypes.any,
  sizePerPage: PropTypes.any,
  t: PropTypes.any,
};


export default withTranslation()(RavenAgTableDoubleClick);
